module.exports = __webpack_public_path__ + "static/media/user-group.f0d0df52.svg";